import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import get from 'lodash/get';
import withConfig from '../../hoc/WithConfig';
import Select from './Select';
import messagesHomes from './messages.homes';
import messagesProducts from './messages.products';

class SelectTypes extends React.PureComponent {
  constructor(props) {
    super(props);

    switch (props.config.verticalName) {
      case 'products':
        this.optionsSorted = true;
        this.messages = messagesProducts;
        break;
      default:
        this.messages = messagesHomes;
        break;
    }
  }

  render() {
    const { name, selectedOption, size, placeholder, onChange, style, intl, config } = this.props;
    const clientTypes = get(config, ['vertical', 'types']);
    const types = {};

    Object.keys(clientTypes).forEach(key => {
      types[key] = intl.formatMessage(this.messages[key]);
    });

    return (
      <Select
        options={types}
        optionsSorted={this.optionsSorted}
        name={name}
        size={size}
        selectedOption={selectedOption}
        placeholder={placeholder}
        onChange={onChange}
        style={style}
      />
    );
  }
}

SelectTypes.defaultProps = {
  name: 'type',
  size: 'medium',
  selectedOption: undefined,
  placeholder: null,
  style: null,
  optionsSorted: false,
};

SelectTypes.propTypes = {
  name: PropTypes.string,
  selectedOption: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.object,
  intl: intlShape.isRequired,
  config: PropTypes.object.isRequired,
};

export default injectIntl(withConfig(SelectTypes));



// WEBPACK FOOTER //
// ./app/common/forms/SelectTypes.js